<template>
  <div class="main">
    <TopCtrl/>
    <EmptyListTip
        icon="//res.uuudian.com/hk_data/573136ab-6c83-4cb1-8125-9f124913cb1c"
        text="登录会话已过期，请重新登录"
        primaryButton="重新登录"
        />
     
  </div>
  
</template>

<script>
export default {
  title: '请重新登录',
  bodyClass: 'gray-bg',
  components: {},
  data(){
    return {
        
    }
  }
}
</script>

<style scoped lang="less">

</style>




// WEBPACK FOOTER //
// src/pages/public/NoAuth.vue